import { NotifyHelper } from "../../../helpers/toast";
import { eMLThamSoPhongHocMonHocActionsObj } from "../../action-types/category/IMLThamSoPhongHocMonHocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const mlThamSoPhongHocMonHocActions = {
    ...generateActions(eMLThamSoPhongHocMonHocActionsObj, "ML_THAM_SO_PHONG_HOC_MON_HOC"),
    ...generateActionForKey(eMLThamSoPhongHocMonHocActionsObj, "ML_THAM_SO_PHONG_HOC_MON_HOC", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eMLThamSoPhongHocMonHocActionsObj, "ML_THAM_SO_PHONG_HOC_MON_HOC", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eMLThamSoPhongHocMonHocActionsObj, "ML_THAM_SO_PHONG_HOC_MON_HOC", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eMLThamSoPhongHocMonHocActionsObj, "ML_THAM_SO_PHONG_HOC_MON_HOC", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
